const TOUR_IDS = {
  DASHBOARD: "page-dashboard",
  TEMPLATES: "page-templates",
  REQUESTS: "page-requests",
  VIEW_REQUEST: "page-view-request",
  INBOX: "page-inbox",
  CONTACTS: "page-contacts",
  WEB_FORMS: "page-web-forms",

  INSIGHTS: "page-insights",
  REPORTS: "page-reports",

  BUILDER_UPLOAD: "builder-upload",
  BUILDER_RECIPIENTS: "builder-recipients",
  BUILDER_FIELDS: "builder-fields",
  BUILDER_SEND: "builder-send",
  BUILDER_BULK_SIGNERS: "builder-bulk-signers",

  SELF_SIGN_UPLOAD: "self-sign-upload",
  SELF_SIGN_EDITOR: "self-sign-editor",
} as const;

export default TOUR_IDS;
